export default "/shell-eth.94dc63b6aece8c009e779b3cc2eb098e.svg";